import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

// const Dato = ({styles, elemento}) => {
//   return(
//     <p>{elemento.descrPerfil}</p>
//   )};
 
// const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
//   return (
//     <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
//       <div className="item">
//       <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
//       <List.Header>
//       <div className="floated content" style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
//           <a className="header"><Dato elemento={elemento} /></a>
//         </div>
//         </List.Header>
//         </List.Item>
//       </div>
//     </div>
//   )
// };

// const Lista = ({styles, list, handleClickidLista}) => {
//   const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       {nivel1Detalle}
//     </div>
//   )
// };

const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return (
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPerfil}</td>
    </tr>  
  )
};
const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 handleClickidLista={handleClickidLista} 
   elemento={elemento}
   key={elemento._id} />);
  return(
    <tbody className=''>
    {nivel1Detalle}
  </tbody>
  )
};


const UserPerfil2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a200501 = autorizacUA.findIndex( autorizac => autorizac === "200501" );

  return (
    // <div>
    //   <List selection>
    //   <TitDer list={list} textBoton1="Perfiles" btnNuevo={a200501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

    //   <Lista list={list} styles={styles} handleClickidLista={handleClickidLista}/>
    //   </List> 
    // </div>

<div>
      <List selection>
        <TitDer list={list} textBoton1="Usuarios" btnNuevo={a200501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '50%'}}>Perfil</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
      </List>
    </div>
  )
};

export default UserPerfil2
